import styled from 'styled-components';


export const HomeContainer = styled.div`
  background-color:#EBEBEE;
  height:100%;
  
`;
export const FlexBox=styled.div`
  display:flex
  
`
export const HomeImageContainer = styled.div`
padding-left:200px;
  width:55%;
  background-color:#EBEBEE;
  
`;

export const HomeImage = styled.img` 
  

mix-blend-mode: multiply;
  
`;

export const HomeLoginContainer = styled.div`
padding-right:20px;
width: 25%;
min-height: 100%;
max-height: 100%;
flex-shrink: 0;
  border-radius: 32px;
background: #FFF;
  
`;

